<h3>{{ 'Bookings' | translate }}</h3>
<p>{{ 'What you have bought with us so far' | translate }}</p>
<app-order-info-list [orders]="orders" (orderClick)="orderClick($event)" (paymentClick)="paymentClick($event)" (cancelClick)="cancelClick($event)"></app-order-info-list>
